module.exports = [
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Pillar tap and L size boiler",
		"textblock_1st_text": "30080001",
		"textblock_2nd_text": "GROHE RED Mono kitchen tap (C-spout) with filter set and L size boiler for instant boiling water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Pillar tap and M size boiler",
		"textblock_1st_text": "30085001",
		"textblock_2nd_text": "GROHE RED Mono kitchen tap (C-spout) with filter set and M size boiler for instant boiling water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and L size boiler",
		"textblock_1st_text": "30325DC1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (L-spout) with filter set and L size boiler for instant boiling water. Matte stainless steel look finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and M size boiler",
		"textblock_1st_text": "30327DC1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (L-spout) with filter set and M size boiler for instant boiling water. Matte stainless steel look. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and L size boiler",
		"textblock_1st_text": "30325001",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (L-spout) with filter set and L size boiler for instant boiling water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and M size boiler",
		"textblock_1st_text": "30327001",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (L-spout) with filter set and M size boiler for instant boiling water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and L size boiler",
		"textblock_1st_text": "30079001",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (C-spout) with filter set and L size boiler for instant boiling water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and M size boiler",
		"textblock_1st_text": "30083001",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (C-spout) with filter set and M size boiler for instant boiling water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-spout Starter kit",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High L-spout, chrome finish.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-spout Starter kit",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High L-spout, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-spout Starter kit",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High C-spout, chrome finish.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-spout Starter kit",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High C-spout, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-spout Starter kit",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High U-spout, chrome finish.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-spout Starter kit",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High U-spout, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter kit",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "GROHE Blue Home Mono starter kit: pillar tap for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High C-spout, chrome finish.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30339001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30339001/640/30339001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Pillar tap and M size boiler",
		"textblock_1st_text": "30339001",
		"textblock_2nd_text": "GROHE RED Mono kitchen tap (L-spout) with filter set and M size boiler for instant boiling water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/30339001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and L size boiler",
		"textblock_1st_text": "30079DC1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (C-spout) with filter set and L size boiler for instant boiling water. Matte stainless steel look. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and M size boiler",
		"textblock_1st_text": "30083DC1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (C-spout) with filter set and M size boiler for instant boiling water. Matte stainless steel look. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter kit",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "GROHE Blue Home Mono starter kit: pillar tap for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High C-spout, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/water_products_en_cy.json
// module id = 877
// module chunks = 0